import React, { useState } from "react";
import CreateProject from "./CreateProject";
import CreateBulkProject from "./CreateBulkProject";
import Breadcrumbs from "../../components/Breadcrumbs";
import { useEffect } from "react";
import { useBreadcrumbs } from "../../v2/context/breadcrumb/breadcrumb-context.tsx";
const ProjectTabs = () => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  const { setBreadcrumbs } = useBreadcrumbs();
  const tabs = [
    { label: "Create Project", component: CreateProject },
    { label: "Create Bulk Project", component: CreateBulkProject },
  ];
  useEffect(() => {
    setBreadcrumbs([
      { label: "Project List", path: "/dashboard/projectList" },
      { label: tabs[activeTabIndex].label },
    ]);
  }, [activeTabIndex]);
  return (
    <div className="wrapper-body">
      {/* <div className="page-heading">
        <Breadcrumbs
          items={[
            { label: "Project List", path: "/dashboard/projectList" },
            { label: tabs[activeTabIndex].label },
          ]}
          className="projectListBackButton"
        />
      </div> */}
      <div className="card rounded-lg">
        <div className="d-flex justify-content-between align-items-center ">
          <ul className="nav nav-tabs" role="tablist">
            {tabs.map((item, index) => (
              <li className="nav-item" role="presentation" key={index}>
                <button
                  className={`nav-link ${activeTabIndex === index ? "active" : ""
                    }`}
                  type="button"
                  role="tab"
                  aria-selected={activeTabIndex === index}
                  onClick={() => setActiveTabIndex(index)}
                >
                  {item.label}
                </button>
              </li>
            ))}
          </ul>
        </div>

        <div className="tab-content px-3">
          {tabs.map((item, index) => {
            const Component = item.component;
            return (
              activeTabIndex === index && (
                <div
                  key={index}
                  className={`tab-pane fade show active`}
                  role="tabpanel"
                >
                  <Component title={item.label} description={""} />
                </div>
              )
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ProjectTabs;
